//This file created by sudip
import { ReactNode } from "react";
import { motion } from "framer-motion";

import { fadeUp, viewportOnce } from "@/animations/motion";

interface AnimatedSectionProps {
    children: ReactNode;
    className?: string;
    delay?: number;
}

export function AnimatedSection({
    children,
    className,
    delay = 0,
}: AnimatedSectionProps) {
    return (
        <motion.div
            className={className}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            transition={{
                delay,
            }}
        >
            {children}
        </motion.div>
    );
}